<template>
    <div class="dashboard__view">
        <div class="page">
            <div class="page__title">Admin User</div>
        </div>

        <div @click="$router.go(-1)" class="page__nav">
            <div class="page__nav__icon">
                <svg fill="none" height="16" viewBox="0 0 19 16" width="19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z" fill="#655D79" />
                </svg>
            </div>
            <div class="page__nav__text">Create Admin User</div>
        </div>
        <div class="page__content" v-if="merchantID !== ''">
            <div class="nuban">
                <div class="nuban__title">
                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
                        <path d="M30.7181 3.82796C16.39 3.42171 4.42123 14.7655 4.01497 29.0936C3.60873 43.4217 14.9525 55.4061 29.2806 55.8123C43.6087 56.203 55.5931 44.8748 55.9994 30.5311C56.0775 27.5311 55.6244 24.6405 54.7494 21.9373L51.4525 25.0467C51.8431 26.7811 52.0462 28.578 51.9994 30.4373C51.6556 42.5623 41.515 52.1405 29.39 51.8123C17.265 51.4686 7.67123 41.328 7.99935 29.203C8.3431 17.078 18.4837 7.48422 30.6087 7.81234C34.5775 7.93734 38.265 9.10922 41.4369 11.0623L44.4369 8.21859C40.4994 5.59359 35.8118 3.96859 30.7181 3.82796ZM49.9994 11.1717L25.9993 35.1717L19.4056 28.5936L17.9994 27.1717L15.1712 29.9998L16.5931 31.4061L25.9993 40.828L52.8275 13.9998L49.9994 11.1717Z" fill="#e00b5b" />
                    </svg>
                </div>
                <div class="nuban__title">Admin User Created</div>
                <div class="nuban__caption">Your admin creation was successful</div>
                <div class="nuban__action">
                    <router-link class="btn btn--primary" to="/dashboard/users?page=1">Back to Admin</router-link>
                </div>
            </div>
        </div>
        <div class="page__content" v-else>
            <div class="profile nobar">
                <div class="profile__left">
                    <div class="profile__title">Admin User Details</div>
                    <div class="profile__caption">Be sure to enter the right user details</div>
                </div>
                <div class="profile__right">
                    <div class="form__flex">
                        <div class="form__flex__item">
                            <label class="form__label" for>Full Name</label>
                            <input class="form__input" type="text" @keydown="preventNumericInput" v-model="fullName.value" />
                            <span class="attention" v-if="fullName.empty">Field can't be empty</span>
                        </div>
                        <div class="form__flex__item">
                            <label class="form__label" for>Phone Number</label>
                            <input @keydown="preventKeys" class="form__input num__input" maxlength="11" type="number" v-model="mobileNumber.value" />
                            <span class="attention" v-if="mobileNumber.empty">Field can't be empty</span>
                        </div>
                    </div>
                    <div class="form__flex">
                        <div class="form__flex__item">
                            <label class="form__label" for>Email</label>
                            <input autocomplete="off" class="form__input" type="email" v-model="emailAddress.value" />
                            <span class="attention" v-if="emailAddress.empty">Field can't be empty</span>
                        </div>
                        <div class="form__flex__item">
                            <label class="form__label" for>Password</label>
                            <input autocomplete="new-password" class="form__input" type="password" v-model="password.value" />
                            <span class="attention" v-if="password.empty">Field can't be empty</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="action">
                <button :disabled="disabled" @click="createAdminUser" class="btn btn--primary">Create Admin User</button>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
    metaInfo: {
        title: "Create Admin User"
    },
    data() {
        return {
            fullName: {
                value: "",
                empty: false
            },
            mobileNumber: {
                value: "",
                empty: false
            },
            password: {
                value: "",
                empty: false
            },
            emailAddress: {
                value: "",
                empty: false
            },
            merchantID: "",
            disabled: false
        };
    },

    created() {},
    methods: {
        preventNumericInput($event) {
          let keyCode = $event.keyCode ? $event.keyCode : $event.which;
          if (keyCode > 47 && keyCode < 58) {
            $event.preventDefault();
          }
        },
        resetState() {
            this.fullName.empty = false;
            this.mobileNumber.empty = false;
            this.password.empty = false;
            this.emailAddress.empty = false;
        },
        clearData() {
            this.fullName.value = "";
            this.mobileNumber.value = "";
            this.password.value = "";
            this.emailAddress.value = "";
        },

        createAdminUser(value) {
            this.resetState();
            if (this.fullName.value !== "" && this.mobileNumber.value !== "" && this.password.value !== "" && this.emailAddress.value !== "") {
                this.disabled = true;
                let requestObject = {
                    role: "admin",
                    email: this.emailAddress.value.trim(),
                    mobile_number: this.mobileNumber.value.trim(),
                    fullname: this.fullName.value.trim(),
                    password: this.password.value.trim()
                };
                this.$http
                    .post("admin/create_new_admin_user", requestObject)
                    .then(response => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "success text-white",
                            title: "Success",
                            text: response.body.message
                        });
                        this.merchantID = "Merchant";
                        // clear data
                        this.clearData();
                    })
                    .catch(error => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "error text-white",
                            title: "Error",
                            text: error.body.message
                        });
                    });
            } else {
                if (this.fullName.value == "") {
                    this.fullName.empty = true;
                }
                if (this.mobileNumber.value == "") {
                    this.mobileNumber.empty = true;
                }
                if (this.password.value == "") {
                    this.password.empty = true;
                }
                if (this.emailAddress.value == "") {
                    this.emailAddress.empty = true;
                }
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.num__input::-webkit-inner-spin-button,
.num__input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.nuban {
    padding: 100px 25px 120px;
    text-align: center;
    &__number {
        color: #e8368f;
        font-size: 32px;
        line-height: 35px;
        padding: 19px 28px 15px;
        background-color: rgba(#e8368f, 0.15);
        border-radius: 16px;
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 32px;
        position: relative;
    }

    &__title {
        color: #261940;
        font-size: 18px;
        line-height: 20px;
        margin-bottom: 16px;
    }

    &__caption {
        color: rgba(#261940, 0.8);
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 32px;
    }

    &__copy {
        position: absolute;
        color: #e00b5b;
        font-size: 12px;
        line-height: 13px;
        top: -20px;
        right: 0;
        cursor: pointer;
    }
}
</style>